<div class="spinner-wrapper" fxLayout="row" fxLayoutAlign="start center">
  <mat-spinner [diameter]="diameter" [strokeWidth]="stroke"></mat-spinner>
  <span><ng-content></ng-content></span>
</div>
